<!--
   Created by qing on 2020/12/19
   Des: 评论回复历史
-->
<template>
  <van-popup
    class="comment-reply-list-popup"
    v-model="dialogVisible"
    closeable
    position="bottom"
    get-container="body"
    :style="{ height: '90%', width: '100%' }"
    @close="dialogClose">
    <div class="comment-reply-list-header">
      回复列表
    </div>
    <div class="reply-list-content" v-if="replyInfo">

      <div class="root-comment-item comment-item">
        <div class="user-img">
          <el-image
            style="width: 50px; height: 50px;"
            :src="replyInfo.headImage"
          ></el-image>
        </div>
        <div class="comment-info">
          <div class="top">
            <div class="user-info">
              <div>
                {{replyInfo.userName}}
              </div>
              <div>
                {{actionFormatTime(replyInfo.commentTime)}}
              </div>
            </div>
            <div class="comment-handle">
              <div
                v-if="!replyInfo.deleteFlag && replyInfo.userId === $store.state.userInfo.userId"
                class="handle-button"
                @click.stop.prevent.left="editRootComment()">
                编辑
              </div>
              <div
                v-if="!replyInfo.deleteFlag && replyInfo.userId === $store.state.userInfo.userId"
                class="handle-button"
                style="color: red;"
                @click.stop.prevent.left="deleteRootComment()">
                删除
              </div>
            </div>
          </div>
          <div class="comment-detail">
            <template v-if="replyInfo && replyInfo.content">
              <div v-if="commentType ==='INSTANCE'" class="comment-content ql-editor" v-html="formatCommentContent(replyInfo)"></div>
              <div v-else class="comment-content ql-editor" v-html="replyInfo.content"></div>
            </template>

            <ul class="file__list">
              <li v-for="(file, idx) in replyInfo.attachmentList">
                <div class="file__icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                  </svg>
                </div>
                <div class="file__info">
                  <div class="file__info-name">
                    {{file.fileName}}
                  </div>
                  <div class="file__info-bottom">

                    <div class="file__info-size">
                      {{file.fileSize}}KB
                    </div>
                    <div class="file__info-handle">
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="previewFile(file)">
                        预览
                      </div>
                      <div class="divider"></div>
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="downloadFile(file)">
                        下载
                      </div>
                      <div class="divider"></div>
                      <div
                        v-if="replyInfo.userId === $store.getters.userId"
                        class="handle-button"
                        @click="openFileAccessRecords(file.fileUrl)">
                        访问记录
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <van-divider content-position="left">{{replyListLength}}条回复</van-divider>

      <div
        class="comment-item"
        v-for="(item, idx) in replyInfo.replyList"
        v-if="!item.deleteFlag"
        :key="item.commentId">
        <div class="user-img">
          <el-image
            style="width: 30px; height: 30px;"
            :src="item.headImage"
          ></el-image>
        </div>
        <div class="comment-info">
          <div class="top">
            <div class="user-info">
              <div>
                {{item.userName}}
              </div>
              <div>
                {{actionFormatTime(item.commentTime)}}
              </div>
            </div>
            <div class="comment-handle" v-if="!$store.getters.isGuest">
              <div
                class="handle-button"
                @click.stop.prevent.left="replyComment(item)">
                回复
              </div>
              <div
                v-if="item.userId === $store.getters.userId"
                class="handle-button"
                @click.stop.prevent.left="editComment(item)">
                编辑
              </div>
              <div
                v-if="item.userId === $store.getters.userId"
                class="handle-button"
                style="color: red;"
                @click.stop.prevent.left="deleteComment(item, idx)">
                删除
              </div>
            </div>
          </div>
          <div class="reply-container" v-if="fetchSourceComment(item.replyId)">
            <div class="line"></div>
            <div class="reply-content">
              回复&nbsp;&nbsp;{{fetchSourceComment(item.replyId).userName}}:&nbsp;{{fetchSourceContent(item.replyId)}}
            </div>
          </div>
          <div class="comment-detail">
            <template v-if="item && item.content">
              <div v-if="commentType ==='INSTANCE'" class="comment-content ql-editor" v-html="formatCommentContent(item)"></div>
              <div v-else class="comment-content ql-editor" v-html="item.content"></div>
            </template>

            <ul class="file__list">
              <li v-for="(file, idx) in item.attachmentList">
                <div class="file__icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                  </svg>
                </div>
                <div class="file__info">
                  <div class="file__info-name">
                    {{file.fileName}}
                  </div>
                  <div class="file__info-bottom">

                    <div class="file__info-size">
                      {{file.fileSize}}KB
                    </div>
                    <div class="file__info-handle" v-if="!$store.getters.isGuest">
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="previewFile(file)">
                        预览
                      </div>
                      <div class="divider"></div>
                      <div
                        class="handle-button"
                        @click.stop.prevent.left="downloadFile(file)">
                        下载
                      </div>
                      <div class="divider"></div>
                      <div
                        v-if="item.userId === $store.getters.userId"
                        class="handle-button"
                        @click="openFileAccessRecords(file.fileUrl)">
                        访问记录
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-input" v-if="!$store.getters.isGuest">

      <FormCommentInput
        v-if="commentType ==='INSTANCE'"
        ref="commentInput"
        :instanceId="instanceId"
        :viewId="viewId"
        :stepId="stepId"
        :commentLocation="commentLocation"
        commentType="INSTANCE"
        :fetchSourceContent="fetchSourceContent"
        @focusComment="focusComment"
        @submitCommentComplete="submitComment"
      ></FormCommentInput>

      <CommentInput
        v-else
        ref="commentInput"
        :nodeId="nodeId"
        :itemId="itemId"
        :mixFormId="mixFormId"
        :commentType="commentType"
        :fetchSourceContent="fetchSourceContent"
        @focusComment="focusComment"
        @submitCommentComplete="submitComment"
      ></CommentInput>
    </div>

    <template>

      <file-access-records
        v-if="commentType ==='INSTANCE'"
        ref="fileAccessRecords"
        popupHeight="90%"
        position="bottom"
        :overlay="true"
        :stackList="stackList"
      ></file-access-records>

      <file-access-records
        v-else
        ref="fileAccessRecords"
        :stackList="stackList"
      ></file-access-records>
    </template>

    <template>

      <file-preview-popup
        v-if="commentType ==='INSTANCE'"
        ref="filePreviewPopup"
        popupHeight="90%"
        position="bottom"
        :overlay="true"
        :stackList="stackList"
      ></file-preview-popup>

      <file-preview-popup
        v-else
        ref="filePreviewPopup"
        :stackList="stackList"
      ></file-preview-popup>
    </template>



  </van-popup>
</template>

<script>
  import CommentInput from "./CommentInput";
  import {accurateFormatDate, fileType2FileImage, clone, getSimpleText} from "../../../assets/js/Untis";
  import FileAccessRecords from "./FileAccessRecords";
  import FilePreviewPopup from "./FilePreviewPopup";
  import FormCommentInput from "../FormCommentInput";

  export default {
    components: {
      CommentInput,
      FileAccessRecords,
      FilePreviewPopup,
      FormCommentInput
    },
    props: {
      nodeId: {
        type: String,
        default: ''
      },
      itemId: {
        type: String,
        default: ''
      },
      mixFormId: {
        type: String,
        default: ''
      },
      commentType: {
        type: String,
        default: 'NODE' // NODE/ ITEM
      },
      stackList: {
        type: Array,
        default: () => []
      },

      instanceId: {
        type: String,
        default: ''
      },
      // 评论的位置 view 视图 DATA 管理数据 FLOW 流程
      commentLocation: {
        type: String,
        default: 'DATA'
      },
      viewId: {
        type: String,
        default: ''
      },
      stepId: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        dialogVisible: false,
        replyInfo: null,
        aEle: null,
        downloadEle: null,
      }
    },
    created() {
      if (!this.aEle) this.aEle = document.createElement('a')
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    computed: {
      replyListLength() {
        let index = 0
        this.replyInfo.replyList.forEach(comment => {
          if (!comment.deleteFlag) {
            index++
          }
        })
        return index
      }
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      open({commentId, rootId}) {

        this.dialogVisible = true

        this.$store.dispatch('actionCommentReplyList', {
          commentId,
          rootId
        }).then(res => {
          this.replyInfo = res
        }).catch(console.error)
      },

      close() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.close()
        }
        this.dialogVisible = false
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },
      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      previewFile(file) {
        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }
        // const loading = this.$toast.loading()
        // this.$store.dispatch('actionNodeSave', {
        //   ...file,
        //   preview_type: 'MIX_FORM',
        //   userId: this.$store.getters.userId,
        //   companyId: this.$store.getters.currentCompanyId,
        //   token: this.$store.state.token
        // }).then(res => {
        //   this.$router.push({
        //     name: 'filePreview',
        //     query: {
        //       k: res.nodeKey
        //     }
        //   })
        // }).catch(console.error)
        //   .finally(() => {
        //     loading.clear()
        //   })

      },
      previewImage(e) {
        const ele = e.target.parentNode.parentNode.firstChild.firstChild
        if (ele) ele.click()
      },

      // 获取回复的评论
      fetchSourceComment(commentId) {
        return this.replyInfo.replyList.filter(comment => comment.commentId === commentId)[0]
      },
      // 获取回复的评论的字符串内容
      fetchSourceContent(commentId) {
        const comment = this.fetchSourceComment(commentId) || this.replyInfo
        if (!comment) {
          return ''
        }
        let content = getSimpleText(comment.content)
        if (this.commentType ==='INSTANCE') {
          content = getSimpleText(this.formatCommentContent(comment))
        }
        content += comment.content.includes('<img') ? '【图片】' : ''
        content += comment.content.includes('<video') ? '【视频】' : ''
        if (!content) {
          if (comment.attachmentList && comment.attachmentList.length) {
            content = '【附件】'
          }
        }
        return content
      },

      // 首次填写评论
      focusComment() {
        if (this.replyInfo.deleteFlag) {
          this.$toast.fail('源评论已被删除，不能再回复')
          return
        }
        if (this.$refs.commentInput) {
          const replyCommentInfo = clone(this.replyInfo)
          delete replyCommentInfo.replyList
          this.$refs.commentInput.open({
            commentStatus: 'REPLY',
            replyCommentInfo
          })
        }
      },
      // 回复评论
      replyComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'REPLY',
            replyCommentInfo: item
          })
        }
      },
      // 编辑评论
      editComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'EDIT',
            commentInfo: clone(item)
          })
        }
      },
      // 删除评论
      deleteComment(item, idx) {
        this.$dialog.confirm({
          title: '提示',
          message: '删除评论后将无法恢复，是否删除?',
          confirmButtonText: '删除',
        }).then(() => {
          this.$store.dispatch('actionCommentDelete', {
            ...item
          }).then(res => {
            this.$toast.success('删除成功')
            item.deleteFlag = 1
            item.content = `${item.userName}已删除评论`
          }).catch(console.error)

        }).catch(action => {
        })
      },
      // 发表评论
      submitComment({commentStatus, commentInfo}) {
        if (commentStatus === 'EDIT') {
          const comment = this.replyInfo.replyList.filter(comment => comment.commentId === commentInfo.commentId)[0]
          if (comment) {
            comment.content = commentInfo.content
            comment.attachmentList = commentInfo.attachmentList
          } else {
            this.replyInfo.content = commentInfo.content
            this.replyInfo.attachmentList = commentInfo.attachmentList
          }
        } else {
          this.replyInfo.replyList.push(commentInfo)
        }
      },
      // 编辑源评论
      editRootComment() {
        const replyCommentInfo = clone(this.replyInfo)
        delete replyCommentInfo.replyList
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'EDIT',
            commentInfo: clone(replyCommentInfo)
          })
        }
      },
      // 删除源评论
      deleteRootComment() {
        this.$store.dispatch('actionCommentDelete', {
          ...this.replyInfo
        }).then(res => {
          this.$toast.success('删除成功')
          this.dialogVisible = false
        }).catch(console.error)
      },
      dialogClose() {
        this.$emit('reply-close')
      },
      formatCommentContent(item) {
        const fields = {}
        Object.keys(this.$store.getters.userListMap).forEach(userId => {
          const user = this.$store.getters.userListMap[userId]
          fields[userId] = {
            envVarName: userId,
            fieldTitle: user.nickname,
          }
        })
        Object.keys(this.$store.getters.extMap).forEach(userId => {
          const user = this.$store.getters.extMap[userId]
          fields[userId] = {
            envVarName: userId,
            fieldTitle: user.orgUserName,
          }
        })
        const varList = Object.keys(fields)
        const str = item.content
        const newStr = str.replace(new RegExp(`\\$(${varList.join('|')})\\$`, "ig"), (fieldTxt, fieldId, idx) => {
          const field = fields[fieldId]
          return `<span style="color: #1b9aee; margin: 0 5px;">@${field.fieldTitle}</span>`
        })
        return newStr
      },
    }
  }
</script>

<style lang="less">

  .comment-reply-list-popup {

    .van-popup__close-icon {
      top: 8px;
    }

    .comment-reply-list-header {
      color: #333;
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
    }

    .reply-list-content {
      position: absolute;
      top: 40px;
      left: 20px;
      right: 0;
      bottom: calc(65px + env(safe-area-inset-bottom));
      padding-right: 20px;
      overflow: auto;

      .reply-container {
        background-color: #F4F4FA;
        padding: 10px;
        display: flex;
        width: 100%;
        cursor: pointer;

        .line {
          width: 3px;
          height: 12px;
          background-color: #909399;
          margin-right: 10px;
        }

        .reply-content {
          font-size: 12px;
          width: calc(100% - 20px);
          color: #909399;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }
      }

      .comment-item {
        width: 100%;
        display: flex;
        padding: 10px 0;
        border-bottom: 1px dashed #e6e6e6;

        .user-img {
          width: 40px;

          .el-image {
            border-radius: 50%;
          }
        }

        .comment-info {
          width: calc(100% - 40px);

          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .user-info {
              display: flex;

              > div {
                font-size: 12px;
                color: #6d6d6d;
                margin-right: 10px;
              }
            }

            .comment-handle {
              display: flex;
              align-items: center;

              .handle-button {
                margin-right: 10px;
              }
            }
          }

          .comment-detail {

            .ql-editor {
              padding: 10px 10px 10px 0;
            }

            .comment-content {
              font-size: 12px;
              color: #333;

              img, video {
                max-width: 100%;
              }
            }

            .file__list {

            }
          }
        }
      }

      .root-comment-item {
        border-bottom: none !important;

        .user-img {
          width: 60px;
          padding-top: 0;
        }
        .comment-info {
          width: calc(100% - 60px);
        }
      }
    }

    .comment-input {
      position: absolute;
      height: 50px;
      bottom: calc(env(safe-area-inset-bottom));
      left: 0;
      right: 0;
    }
  }
</style>
